import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a83f117"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "checkbox-wrapper hover"
}

import { GetterTypes, MutationTypes, store } from "@/store";
import { IconType } from "@/types/icons";
import Icon from "../icons/Icon/Icon.vue";
import { useComputedValue } from "@/composables";
import { NonAutomaticMessage } from "@/store/chats/types";

interface Props {
  message: NonAutomaticMessage;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckboxSelectMessage',
  props: {
    message: {}
  },
  setup(__props: any) {



const selectedMessageIds = useComputedValue<string[] | null>(
  GetterTypes.GET_SELECTED_MESSAGE_IDS,
);

const toggleSelectMessage = (messageId: string) => {
  store.commit(MutationTypes.TOGGLE_SELECTED_MESSAGE_ID, { messageId });
};

return (_ctx: any,_cache: any) => {
  return (_ctx.message.isMine && _unref(selectedMessageIds))
    ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
        _createVNode(Icon, {
          icon: 
        _unref(selectedMessageIds).includes(_ctx.message.id)
          ? _unref(IconType).CHECKBOX_ON
          : _unref(IconType).CHECKBOX_OFF
      ,
          class: "checkbox",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleSelectMessage(_ctx.message.id)))
        }, null, 8, ["icon"])
      ]))
    : _createCommentVNode("", true)
}
}

})